/**
 * Global message processor to prevent duplicate message processing
 */
class MessageProcessor {
    constructor() {
        this.processedMessages = new Set();
        this.subscribers = new Set();
    }
    static getInstance() {
        if (!MessageProcessor.instance) {
            MessageProcessor.instance = new MessageProcessor();
        }
        return MessageProcessor.instance;
    }
    subscribe(callback) {
        this.subscribers.add(callback);
        return () => {
            this.subscribers.delete(callback);
        };
    }
    processMessage(message) {
        if (!message || !message.payload || !message.payload.message) {
            return false;
        }
        const messageId = `${message.payload.message.id}_${message.payload.message.createdDate}`;
        if (this.processedMessages.has(messageId)) {
            return false;
        }
        this.processedMessages.add(messageId);
        if (this.processedMessages.size > 100) {
            const messageIds = Array.from(this.processedMessages);
            this.processedMessages.clear();
            messageIds.slice(-50).forEach((id) => this.processedMessages.add(id));
        }
        this.subscribers.forEach((callback) => {
            try {
                callback(message);
            }
            catch (error) {
                console.error('Error in message subscriber:', error);
            }
        });
        return true;
    }
    clear() {
        this.processedMessages.clear();
    }
}
export default MessageProcessor;
